import { useContributors } from '../api/getContributors';

import { ContributorItem } from './ContributorItem';

import { User } from '@/features/users';

interface ContributorProps {
  companyId: string;
  users: User[];
}

export const ContributorList = ({ companyId, users }: ContributorProps) => {
  const contributorsQuery = useContributors({ companyId });
  const contributors = contributorsQuery.data || [];
  const statusOfUser = (userId: string) => {
    const user = users.find((u) => u.id == userId);
    return user ? user.status : 'CANCELED';
  };
  return (
    <>
      {contributors.map((contributor) => {
        const status = statusOfUser(contributor.user.id);
        // ! patch status of user!
        // @2025/09/30
        contributor.user.status = status;
        return (
          <ContributorItem
            key={`${contributor.user.id}-${contributor.role.id}`}
            contributor={contributor}
          />
        );
      })}
    </>
  );
};
